export const fingotiAuthConfig = {
    authBaseUrl: process.env.REACT_APP_AUTH_BASE_URL,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_ACCOUNT_URL,
};

let _auth = null;

export const setAuth = (auth) => {
    _auth = auth;
};

export const getAccessToken = async (opts) => {
    if (!_auth) {
        throw new Error('FingotiAuth not initialised yet');
    }
    return _auth.getAccessToken(opts);
};

export const logout = (opts) => {
    if (!_auth) return Promise.reject(new Error('FingotiAuth not initialised yet'));
    return _auth.logout(opts);
};
